<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">协议</span>
    </navbar>
    <div class="page-content">
      <iframe ref="frame" :src="protocolUrl" frameborder="0" class="frame"></iframe>
    </div>
    <spinner :show="loading"></spinner>
  </div>
</template>
<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        protocolUrl: ''
      }
    },
    components: {
      Navbar,
      Spinner
    },
    created () {
      this.orderId = this.$route.params.id
      this.token = this.$cache.getUserToken()
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/czBank/getLoanContractUrl.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + vm.orderId + '1' + vm.token.mac),
            orderId: vm.orderId
          },
          done (d) {
            vm.protocolUrl = d.plugUrl + '?url=' + window.decodeURIComponent(d.fileUrl)
          },
          always () {
            vm.loading = false
          }
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .frame
    position absolute
    width 100%
    height 100%
    top 0
    bottom 0
    left 0
    overflow hidden
</style>



// WEBPACK FOOTER //
// protocol.vue?c725ae96